<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <add :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" @notify="notify" :data="sidebarData" :theme="$store.state.themes.current" />

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">


          <!-- ADD NEW -->
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
        
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Version</vs-th>
        <vs-th>Date</vs-th>
        <vs-th>Changes</vs-th>
        <!-- <vs-th>Action</vs-th> -->
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
               <vs-chip v-if="tr.tag.version" :color="'primary'" class="product-order-status">{{ tr.tag.version }}</vs-chip>
            </vs-td>

            <vs-td>
              <p v-if="tr.tag.date" class="product-name font-medium truncate">{{ tr.tag.date }}</p>
            </vs-td>

            <vs-td>
              <ul class="uicore-log">
                  <li
                      :key="index"
                      v-for="(change, index) in tr.tag.changes"
                      :class="'uicore-change-' + change.type"
                      v-html="change.info"
                  ></li>
              </ul>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="CopyIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="copy(tr)" />
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import add from './add.vue'
import moduleChangelogList from "@/store/changelog/moduleChangelogList.js"

export default {
  components: {
    add
  },
  data() {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 20,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products() {
      return this.$store.state.changelogList.products.slice().reverse();
    },
    queriedItems() {
        var def = 0;
        if (typeof this.products === 'object'){
            def = this.products.length
        }
      return this.$refs.table ? this.$refs.table.queriedResults.length : def
    }
  },
  methods: { 
    copy(e) {
       navigator.clipboard.writeText( JSON.stringify(e.tag.changes) );
    },
    notify(e){
        console.log(e);
        this.$vs.notify(e)
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData(tr) {
        var id = tr.id
      this.$store.dispatch("pagesList/removeItem", id).then(()=> {
      }).catch(err => { console.error(err) })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    }
  },
  created() {
    if(!moduleChangelogList.isRegistered) {
      this.$store.registerModule('changelogList', moduleChangelogList)
      moduleChangelogList.isRegistered = true
    }
    this.$store.dispatch("changelogList/fetchDataListItems", this.$store.state.themes.current)
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
.uicore-log {
    li {
        display: flex;
        align-items: center;
        margin-bottom: 14px;

        &:before {
            content: 'NEW';
            background: green;
            border-radius: 4.5px;
            color: #fff;
            font-size: 10px;
            line-height: 19px;
            font-weight: 600;
            padding: 0 5px 0 6px;
            letter-spacing: 0.4px;
            -webkit-font-smoothing: antialiased;
            min-width: 25px;
            margin-right: 10px;
            text-align: center;
        }

        &.uicore-change-upd:before {
            content: 'UPD';
            background: blueviolet;
        }
        &.uicore-change-fix:before {
            content: 'FIX';
            background: red;
        }
    }
}
.uicore-small-separator {
    margin-top: 33px;
    opacity: 1 !important;
    margin-bottom: 20px;
}

#data-list-thumb-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
